var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"no-data-dashed-box__icon"}),_vm._v(" "),_c('div',{staticClass:"no-data-dashed-box__text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fbbedf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generics/no-data-dashed-box/no-data-dashed-box.vue
// module id = /ELm
// module chunks = 65